export default function () {
    const $totopbtn = document.querySelector('.scroll-top');

    if (!$totopbtn) {
        return;
    }

    // define header spacer
    const headerScollSpacer = 375;

    function checkTopScroll() {
        if (window.pageYOffset >= headerScollSpacer) {
            $totopbtn.classList.add('scroll-top-active');
        } else {
            $totopbtn.classList.remove('scroll-top-active');
        }
    }

    window.addEventListener('load', () => {
        checkTopScroll();
    });

    window.addEventListener('scroll', checkTopScroll, {
        passive: true,
    }); // eslint-disable-line
}
